import apiClient from '@u/apiClient'
import GetItemCategoryListController from '@/wayfinder/actions/App/Http/Controllers/ItemCategory/GetItemCategoryListController'
import GetItemCategoryByIdController from '@/wayfinder/actions/App/Http/Controllers/ItemCategory/GetItemCategoryByIdController'
import CreateItemCategoryController from '@/wayfinder/actions/App/Http/Controllers/ItemCategory/CreateItemCategoryController'
import UpdateItemCategoryController from '@/wayfinder/actions/App/Http/Controllers/ItemCategory/UpdateItemCategoryController'
import UpdateMultipleItemCategoryController from '@/wayfinder/actions/App/Http/Controllers/ItemCategory/UpdateMultipleItemCategoryController'
import GetItemsByCategoryController from '@/wayfinder/actions/App/Http/Controllers/ItemCategory/GetItemsByCategoryController'
import ReorderItemsInCategoryController from '@/wayfinder/actions/App/Http/Controllers/ItemCategory/ReorderItemsInCategoryController'
import DeleteItemCategoryController from '@/wayfinder/actions/App/Http/Controllers/ItemCategory/DeleteItemCategoryController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
// import router from '@/router'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  async fetchItemCategoryIndex({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetItemCategoryListController.get())
      .then(async (response) => {
        await commit('setItemCategoryList', response.data.item_categories)
        await commit('setMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchItemCategoryIndex', reason)
      })
  },
  async fetchItemCategoryByID({ commit }, id) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetItemCategoryByIdController.get({ itemCategory: id }))
      .then(async (response) => {
        commit('setItemCategory', response.data.item_category)
      })
      .catch(async (reason) => {
        console.error('fetchItemCategoryByID', reason)
      })
  },
  async fetchNewItemCategory({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'itemCategory' } }))
      .then(async (response) => {
        console.log('data', response.data.itemCategory)
        commit('setItemCategory', response.data.itemCategory)
      })
      .catch(async (reason) => {
        console.error('fetchNewItemCategory', reason)
      })
  },
  // endregion

  // region store
  async storeNewItemCategory({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(CreateItemCategoryController.post(), payload.item_category)
      .then(async (response) => {
        if (response.status === 201) {
          commit('setItemCategory', response.data.item_categories)
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('storeNewItemCategory', reason)
      })
  },
  // endregion

  // region update
  async updateItemCategory({ commit }, payload) {
    console.log('action', payload.item_category)
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        UpdateItemCategoryController.put({ itemCategory: payload.id }),
        payload.item_category
      )
      .then(async (response) => {
        if (response.status === 201) {
          await commit('setItemCategoryList', response.data.item_categories)
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('updateItemCategory', reason)
      })
  },
  // endregion

  // region update
  async updateMultipleItemCategory({ commit }, payload) {
    console.log('action', payload)
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(UpdateMultipleItemCategoryController.post(), payload)
      .then(async (response) => {
        if (response.status === 201) {
          await commit('setItemCategoryList', response.data.item_categories)
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('updateMultipleItemCategory', reason)
      })
  },
  // region items
  async fetchItemsByCategoryId({ commit }, payload) {
    return await apiClient
      .route(
        GetItemsByCategoryController.get({ itemCategory: payload.categoryId }),
        {
          params: { page: payload.page, per_page: 50 }
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((reason) => {
        console.error('fetchItemsByCategoryId', reason)
      })
  },
  async reorderItemsInCategory({ commit }, payload) {
    await apiClient
      .route(
        ReorderItemsInCategoryController.put({
          itemCategory: payload.categoryId
        }),
        {
          items: payload.items
        }
      )
      .then((response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('reorderItemsInCategory', reason)
      })
  },
  // endregion

  // region delete
  async deleteItemCategoryById({ commit }, payload) {
    await apiClient
      .route(
        DeleteItemCategoryController.delete.delete({ itemCategory: payload.id })
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setItemCategoryList', response.data.item_categories)
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteItemCategoryById', reason)
      })
  },
  // endregion

  // region undoDelete
  async undoDeleteItemCategoryById({ commit }, payload) {
    await apiClient
      .route(DeleteItemCategoryController.undo.get({ id: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setItemCategoryList', response.data.item_categories)
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteItemCategoryById', reason)
      })
  }
  // endregion
}
